import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Container } from 'flux/utils';
import UserActions from '../../actions/UserActionCreator';
import UserSkillStore from '../../stores/UserSkillStore';
import MySkillSegment from './MySkillSegment';

class MySkillContainer extends Component {

    componentDidMount() {
        UserActions.getSkillsByUser(this.props.userId);
    }

    render() {

        return (
            <MySkillSegment skills={this.state.skills} {...this.props} />
        );
    }
}

MySkillContainer.getStores = () => ([UserSkillStore]);
MySkillContainer.calculateState = (prevState, {userId}) => ({
    skills: UserSkillStore.getCurrent(userId) || [],
});

MySkillContainer.propTypes = {
    userId: PropTypes.number.isRequired,
    menuItems: PropTypes.array
};

export default Container.create(MySkillContainer, {withProps: true});
